import { render, staticRenderFns } from "./RelatorioCash.vue?vue&type=template&id=ad945b60&"
import script from "./RelatorioCash.vue?vue&type=script&lang=js&"
export * from "./RelatorioCash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports